<template>
<v-flex class="neg-margin text-xs-center" xs12>
  <div class="neg-margin banner-bg pt-5 elevation-7"><div class="neg-margin pt-5 banner-mask"><div class="neg-fix pt-3">
    <v-layout row wrap justify-center>
      <v-flex class="pb-3" xs12 md10 lg8>
        <v-jumbotron :height="width < 350 ? '500px' : width < 450 ? '400px' : '300px'">
          <v-container grid-list-md fill-height>
            <v-layout align-center>
              <v-flex xs12>
                <h1 class="pb-2 caps spaced">About Rophem</h1>
                <h2 class="pb-3"><i>Rophem Nursing is a small family owned business dedicated to the success of every single one of our students, whether it’s your first time or your 50th!</i></h2>
              </v-flex>
            </v-layout>
          </v-container>
        </v-jumbotron>
      </v-flex>
    </v-layout>
  </div></div></div>

  <v-layout class="py-4 px-2" row wrap justify-center>
    <v-flex class="pt-3" xs12>
      <h1 class="caps spaced">Who We Are</h1>
    </v-flex>
    <v-flex class="pb-4 text-xs-left" xs12 md10 lg8>
      <p class="headline">Rophem began as a tutoring endeavor through Ms. Mo, who initially began teaching her classmates and their friends in a library. As words spread, and many licenses were earned, Ms. Mo saw a need for students who were struggling with the NCLEX to find a way to defeat the beast.</p>
      <p class="headline">With many years of teaching experience under her belt, she took to the books and formulated our proven Rophem NCLEX Review Curriculum and Study Guide to help nursing graduates pass the NCLEX.</p>
      <p class="headline">We stress the importance of utilizing all the weapons in your arsenal to defeat the NCLEX beast and achieve that license, and that not only includes what we give you, but also what you come with.</p>
    </v-flex>
    <v-flex xs12></v-flex>
    <v-flex xs4 md3>
      <v-divider class="pb-1"></v-divider>
    </v-flex>
    <v-flex xs12></v-flex>
    <v-flex class="pt-3" xs12>
      <h1 class="caps spaced">Our Vision</h1>
    </v-flex>
    <v-flex class="pb-4 text-xs-left" xs12 md10 lg8>
      <p class="headline">Here at Rophem, we envision a world where nurses ... and we believe that through our program, we can bring about that world, one nurse at a time.</p>
    </v-flex>
  </v-layout>

</v-flex>
</template>

<script>
export default {
  data: () => ({
    width: Infinity
  }),
  beforeMount () {
    setInterval(() => {
      if (this.width !== window.innerWidth) this.width = window.innerWidth
    }, 500)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/site/about/About.vue